export default "/assets/images/mila-feed-12.5fa47a79afe8de89.mp4";